import React from 'react'
import parse from 'html-react-parser'
import Grid from '@mui/material/Grid';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import { FormatHomePageMessage, DoesThisUserHavePermissionToEditTheFrontPageText } from '../utilities/helperFunctions'
import desk from '../../images/png/desk.png'

class SimpleMills extends React.Component {
    state = {
        message: false,
        messageField: this.props.message,
        notes: false,
        notesField: this.props.notes,
        hasPermissionToEditText: false,
        logoUrl: ''      
    }

    componentDidMount() {

        this.setState({ logoUrl: `${process.env.REACT_APP_STATIC_WEB}/images/${this.props.customerID}/logo1.png` })

        if (this.props.currentUser !== null) {
            if (this.props.currentUser["id"] !== this.props.id) {
                // If we switched users, disable the edit entirely, we'll process this once all of the current user information is updated
                this.setState({ hasPermissionToEditText: false })
            } else {
                this.setState({ hasPermissionToEditText: DoesThisUserHavePermissionToEditTheFrontPageText(this.props.currentUser) })
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.currentUser !== null) {
            if (prevProps.currentUser === null) {
                // Update if we don't have a current user from previous props
                this.setState({ hasPermissionToEditText: DoesThisUserHavePermissionToEditTheFrontPageText(this.props.currentUser) })
            } else {
                // Check and update if we have confirmed the user has switched
                if (prevProps.currentUser["id"] !== this.props.currentUser["id"]) {
                    this.setState({ hasPermissionToEditText: DoesThisUserHavePermissionToEditTheFrontPageText(this.props.currentUser) })
                }
            }
        }
    }

    goToPresentations = (event) => {
        event.preventDefault()
        this.props.history.push("/presentations")
    }

    handleMessageSubmit = (event) => {
        event.preventDefault()
    }

    messageSubmit = (event) => {
        event.preventDefault()
        this.props.updateCustomerMessage(this.props.customerID, this.state.messageField)
        this.setState({ message: false })
    }

    notesSubmit = (event) => {
        event.preventDefault()
        this.props.updateCustomerNotes(this.props.customerID, this.state.notesField)
        this.setState({ notes: false })
    }

    changeMessage = (event) => {
        event.preventDefault()
        this.setState({ messageField: event.target.value })
    }

    changeNotes = (event) => {
        event.preventDefault()
        this.setState({ notesField: event.target.value })
    }

    messageCancel = (event) => {
        event.preventDefault()
        this.setState({ message: false })
    }

    notesCancel = (event) => {
        event.preventDefault()
        this.setState({ notes: false })
    }

    toggleMessage = (event) => {
        this.setState({ message: !this.state.message })
    }

    toggleNotes = (event) => {
        this.setState({ notes: !this.state.notes })
    }

    handleCustomerMessage = () => {
        return <div className="innerBoxes">
            <h3>
                A Message From Category Leadership
                {this.renderEditButton(this.toggleMessage)}
            </h3>
            {!this.state.message ? (
                <div className="textBox" onClick={this.toggleMessage}>
                    <p>
                        {parse(FormatHomePageMessage(this.props.message) || 'This is the XP3 BI Cloud portal, click me to leave Updates for your team')}
                    </p>
                </div>
            ) : (
                <div className="textBox">
                    <textarea
                        className="editableTextBox"
                        onChange={this.changeMessage}
                        onKeyUp={this.handleMessageSubmit}
                        value={
                            this.state.messageField
                            || 'This is the XP3 BI Cloud portal, click me to leave Updates for your team'
                        }
                    />
                    <div className="centerButtons">
                        <button>
                            {' '}
                            <CloseIcon onClick={this.toggleMessage} />
                            {' '}
                        </button>
                        <button>
                            {' '}
                            <DoneIcon onClick={this.messageSubmit} />
                            {' '}
                        </button>
                    </div>
                </div>
            )}
        </div>
    }

    handleCustomerNotes = () => {
        return <div className="innerBoxes">
            <h3>
                Latest Files and Data Updates
                {this.renderEditButton(this.toggleNotes)}
            </h3>
            {!this.state.notes ? (
                <div className="textBox">
                    <p>
                        {parse(FormatHomePageMessage(this.props.notes) || 'This is the XP3 BI Cloud portal, click me to leave Updates for your team')}
                    </p>
                </div>
            ) : (
                <div className="textBox">
                    <textarea
                        className="editableTextBox"
                        onChange={this.changeNotes}
                        onKeyUp={this.handleNotesSubmit}
                        value={
                            this.state.notesField
                            || 'This is the XP3 BI Cloud portal, click me to leave Updates for your team'
                        }
                    />
                    <div className="centerButtons">
                        <button>
                            {' '}
                            <CloseIcon onClick={this.toggleNotes} />
                            {' '}
                        </button>
                        <button>
                            {' '}
                            <DoneIcon onClick={this.notesSubmit} />
                            {' '}
                        </button>
                    </div>
                </div>
            )}
        </div>
    }

    renderEditButton = (toggle) => {
        if (this.state.hasPermissionToEditText) {
            return <button onClick={toggle}>
                {' '}
                <EditIcon />
                {' '}
            </button>
        }
    }

    Capitalize(str) {
        if (str)
            return str.charAt(0).toUpperCase() + str.slice(1);
        else
            return ""
    }

    render() {
        return (<>
            <div className="mainWrapper">
                <div className="bodyPart">
                    <div className="contentWrapper">
                        <div className="dashTop">
                            <div className="welcomeuserLeft">
                                <h3>
                                    Welcome
                <span>{this.Capitalize(this.props.firstName)}</span>
                                </h3>
                                <p>Thanks for joining us, let's get started</p>
                            </div>
                            <div className="welcomeuserRight">
                                <img src={desk} alt="BI Cloud" />
                                <img src={this.state.logoUrl} alt="SM" />
                            </div>
                        </div>
                        <div className="dashBottom">
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    {this.handleCustomerMessage()}
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    {this.handleCustomerNotes()}
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </div>
            </div>
        </>)
    }
}

export default SimpleMills